const commonFormData = () => {
  return {
    content: {
      id: '',
      values: {},
    },
  }
}

const contactFormData = () => {
  const formData = commonFormData()
  formData.content.values = {
    recipient: '',
    category: '',
    subject: '',
    firstname: '',
    lastname: '',
    email: '',
    message: '',
    privacy: '',
  }
  return formData
}

const cupOfFansGroupRegistrationFormData = () => {
  const formData = commonFormData()
  formData.content.values = {
    recipient: '',
    teamname: '',
    maindeclarantfirstname: '',
    maindeclarantlastname: '',
    email: '',
    maindeclarantphone: '',
    maindeclarantmobile: '',
    maindeclarantstreet: '',
    maindeclarantpostcode: '',
    maindeclarantlocation: '',
    furtherteammatemembernumber: '',
    furtherteammatememberfirstname: '',
    furtherteammatememberlastname: '',
    furtherteammatememberbirthdate: '',
    dataprotection: '',
    entryfee: '',
  }
  return formData
}

const cupOfFansRegistrationFormData = () => {
  const formData = commonFormData()
  formData.content.values = {
    recipient: '',
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    mobile: '',
    birthofdate: '',
    position: '',
    membernumber: '',
    street: '',
    postcode: '',
    location: '',
    dataprotection: '',
    confirmation: '',
    entryfee: '',
  }
  return formData
}

const dfbRefereeFormData = () => {
  const formData = commonFormData()
  formData.content.values = {
    recipient: '',
    firstname: '',
    lastname: '',
    email: '',
    streetandnumber: '',
    postcode: '',
    residence: '',
    abonnement: '',
  }
  return formData
}

const fairPlayMedalFormData = () => {
  const formData = commonFormData()
  formData.content.values = {
    recipient: '',
    game: '',
    date: '',
    nationalassociation: '',
    league: '',
    agerange: '',
    displaygesture: '',
    firstnamereporter: '',
    lastnamereporter: '',
    email: '',
    street: '',
    postcode: '',
    location: '',
    phone: '',
  }
  return formData
}

const fanConcernsFormData = () => {
  const formData = commonFormData()
  formData.content.values = {
    recipient: '',
    email: '',
    chairmanfirstname: '',
    chairmanlastname: '',
    chairmanemail: '',
    checkboxFanClubcodex: '',
    consentdataprocessing: '',
    deputyfirstname: '',
    deputylastname: '',
    deputyemail: '',
    deputyfanclubname: '',
    deputyfanclubdescription: '',
    deputyfoundingdate: '',
    deputynumberofmembers: '',
    deputyhometown: '',
  }
  return formData
}

const fanMatchRegistrationFormData = () => {
  const formData = commonFormData()
  formData.content.values = {
    recipient: '',
    membernumber: '',
    firstname: '',
    lastname: '',
    dateofbirth: '',
    street: '',
    postcode: '',
    location: '',
    phone: '',
    email: '',
    encounter: '',
    position: '',
    skilllevel: '',
    remark: '',
  }
  return formData
}

const soccerHeroesFormData = () => {
  const formData = commonFormData()
  formData.content.values = {
    recipient: '',
    email: '',
    nationalassociation: '',
    district: '',
    iwant: '',
    proposerfirstname: '',
    proposerlastname: '',
    proposerclub: '',
    porposerposition: '',
    proposeremail: '',
    salutation: '',
    applicantfirstname: '',
    applicantlastname: '',
    applicantclub: '',
    applicantpositionKinderundJugendtrainerin: '',
    applicantpositionJugendleiterin: '',
    applicantpositionSchiedsrichterin: '',
    traineragerangeFJuniorinnen: '',
    traineragerangeEJuniorinnen: '',
    traineragerangeDJuniorinnen: '',
    traineragerangeCJuniorinnen: '',
    traineragerangeBJuniorinnen: '',
    traineragerangeGJuniorenBambini: '',
    traineragerangeFJunioren: '',
    traineragerangeEJunioren: '',
    traineragerangeDJunioren: '',
    traineragerangeCJunioren: '',
    traineragerangeBJunioren: '',
    traineragerangeAJunioren: '',
    applicantstreet: '',
    applicanthousenumber: '',
    applicantpostcode: '',
    applicantlocation: '',
    applicantphone: '',
    applicantemail: '',
    applicantdateofbirth: '',
    applicantreasonforaward: '',
    applicantfurtherreason: '',
    applicantcareerinclub: '',
    applicantconsentqualificationoffers: '',
    consentPartnerMagazine: '',
    applicanttermsofuse: '',
  }
  return formData
}

const volunteerAwardFormData = () => {
  const formData = commonFormData()
  formData.content.values = {
    recipient: '',
    email: '',
    nationalassociation: '',
    district: '',
    proposerfirstname: '',
    proposerlastname: '',
    proposerclub: '',
    proposerposition: '',
    proposerphone: '',
    proposeremail: '',
    proposerbeginvoluntarywork: '',
    salutation: '',
    applicantfirstname: '',
    applicantlastname: '',
    applicantclub: '',
    applicantposition: '',
    applicantstreet: '',
    applicanthousenumber: '',
    applicantpostcode: '',
    applicantlocation: '',
    applicantphone: '',
    applicantemail: '',
    applicantbirthofdate: '',
    applicantreasonforaward: '',
    applicantfurtherreason: '',
    applicantcareerinclub: '',
    termsofuse: '',
  }
  return formData
}

export const getFormDataDefinition = (formType) => {
  switch (formType) {
    case 'Kontaktformular':
      return contactFormData()
    case 'CupDerFansGruppenanmeldung':
      return cupOfFansGroupRegistrationFormData()
    case 'CupDerFansEinzelanmeldung':
      return cupOfFansRegistrationFormData()
    case 'DFBSchiedsrichterzeitung':
      return dfbRefereeFormData()
    case 'FairPlayMedaille':
      return fairPlayMedalFormData()
    case 'Fanbelange':
      return fanConcernsFormData()
    case 'FanMatchAnmeldung':
      return fanMatchRegistrationFormData()
    case 'Fussballhelden':
      return soccerHeroesFormData()
    case 'Ehrenamtspreis':
      return volunteerAwardFormData()
    case 'JuliusHirschPreis':
    default:
      return commonFormData()
  }
}
